export const MEDIA_ITEM_LIMITS = {
  images: 10,
  videos: 3,
  audios: 3,
};

export const PAGE_MEDIA_LIMITS = {
  images: 30,
  videos: 6,
  audios: 6,
  total: 40,
};

export const MEDIA_FILE_SIZE_LIMITS = {
  image: 15 * 1024 * 1024,
  photo: 15 * 1024 * 1024,
  video: 50 * 1024 * 1024,
  audio: 10 * 1024 * 1024,
};

export const trimMediaItems = (items, limit) => {
  if (!Array.isArray(items)) return [];
  return items.filter(Boolean).slice(0, limit);
};

const hasUrl = (value) => typeof value === 'string' && value.trim().length > 0;

const countUrlArray = (items = []) => {
  if (!Array.isArray(items)) return 0;
  return items.filter((item) => hasUrl(item?.url) || hasUrl(item)).length;
};

export const countModuleMedia = (module = {}) => {
  const data = module.data || {};
  let images = 0;
  let videos = 0;
  let audios = 0;

  images += countUrlArray(data.images);
  images += countUrlArray(data.photos);
  videos += countUrlArray(data.videos);
  videos += countUrlArray(data.videoItems);
  audios += countUrlArray(data.audios);
  audios += countUrlArray(data.audioItems);

  if (hasUrl(data.coverUrl)) images += 1;
  if (hasUrl(data.backgroundImageUrl)) images += 1;
  if (hasUrl(data.posterUrl)) images += 1;

  if (hasUrl(data.videoUrl) && videos === 0) videos += 1;
  if (hasUrl(data.url) && (module.type === 'video_player' || data.mediaType === 'video')) videos += 1;
  if (hasUrl(data.mediaUrl)) {
    if (data.mediaType === 'video') videos += 1;
    else images += 1;
  }

  if (hasUrl(data.audioUrl)) audios += 1;
  if (hasUrl(data.recordedUrl) && data.recordedUrl !== data.audioUrl) audios += 1;
  if (hasUrl(data.songUrl)) audios += 1;

  return { images, videos, audios, total: images + videos + audios };
};

export const countPageMedia = (pageData = {}) => {
  const totals = { images: 0, videos: 0, audios: 0, total: 0 };
  if (hasUrl(pageData.openingCover?.imageUrl) || hasUrl(pageData.openingCover?.url) || hasUrl(pageData.coverImageUrl)) {
    totals.images += 1;
    totals.total += 1;
  }
  (pageData.modules || []).forEach((module) => {
    const counts = countModuleMedia(module);
    totals.images += counts.images;
    totals.videos += counts.videos;
    totals.audios += counts.audios;
    totals.total += counts.total;
  });
  return totals;
};

export const canAddPageMedia = (usage, mediaType, amount = 1) => {
  const key = mediaType === 'image' || mediaType === 'photo' ? 'images' :
    mediaType === 'video' ? 'videos' :
      mediaType === 'audio' ? 'audios' : 'total';
  const nextTypeCount = (usage[key] || 0) + amount;
  const nextTotal = (usage.total || 0) + amount;

  return nextTypeCount <= PAGE_MEDIA_LIMITS[key] && nextTotal <= PAGE_MEDIA_LIMITS.total;
};

export const getMediaLimitMessage = (usage, mediaType) => {
  const label = mediaType === 'audio' ? 'audio notes' : `${mediaType}s`;
  const key = mediaType === 'image' || mediaType === 'photo' ? 'images' :
    mediaType === 'video' ? 'videos' :
      mediaType === 'audio' ? 'audios' : 'total';
  const limit = PAGE_MEDIA_LIMITS[key] || PAGE_MEDIA_LIMITS.total;

  if ((usage.total || 0) >= PAGE_MEDIA_LIMITS.total) {
    return `This gift has reached ${PAGE_MEDIA_LIMITS.total} media files. Remove unused media before uploading more.`;
  }
  return `This gift supports up to ${limit} ${label}. Remove unused media before uploading more.`;
};
